import { createFileRoute } from '@tanstack/react-router'
import { HelmetList } from '@/features/helmets/pages/helmet-list'

export const Route = createFileRoute('/_authenticated/helmets/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <HelmetList />
}
